import axios from "axios";
import { SpecifiedDeadlineSubtaskResultType, SpecificStudentsWithEvaluation } from "@/models/subEvaluation";
import { applyErrorHandlers } from '@/decorators/applyErrorHandler';

const API_SUBEVALUATION_URL = process.env.VUE_APP_API_URL+"/subevaluations";

export default class SubEvaluationController {
    static async fetchListOfStudentsForSpecificDeadlineSubtaskAndSubevaluationResult(specified_data) {
        console.log("Fetching students for specific deadline, subtask, and subevaluation result:", specified_data);
        SpecifiedDeadlineSubtaskResultType.validate(specified_data);
        console.log("Validated specified data:", specified_data);
        const response = await axios.post(`${API_SUBEVALUATION_URL}/get_specified_students_with_evaluations_by_deadline_and_subtask`, specified_data);
        console.log("Result fetched successfully:", response.data);
        // Assuming response.data is an array, map each item to a new instance.
        return response.data.map(item => new SpecificStudentsWithEvaluation(item));
    }
}

applyErrorHandlers(SubEvaluationController);